import { Text, Checkbox, Loader } from '@pukka/ui-components';
import { useSnapshot } from 'valtio';

import { GeneralFormState, GopayActivationFormState, onChangeValue } from './GopayActivationForm.state';

function TnCForm() {
  const { isTnCApproved } = useSnapshot(GeneralFormState);
  const { isLoading } = useSnapshot(GopayActivationFormState);

  return isLoading ? (
    <div className="text-center">
      <Loader size={200} className="m-auto" />
      <Text>This will take some minutes. Please wait...</Text>
    </div>
  ) : (
    <div>
      <Text as="h3" variant="title-2" weight="bold" className="mb-4" color="blue">
        Persetujuan Moka Digital Payment
      </Text>
      <Text>
        Setelah kirim form ini wajib isi form Persetujuan Layanan Moka Digital Payment di link berikut:{' '}
        <Text as="a" href="https://bit.ly/ewalletconsent" target="_blank" className="underline" color="link">
          https://bit.ly/ewalletconsent
        </Text>
      </Text>
      <Text className="my-4" variant="body-2" color="secondary">
        Pendaftaran E-wallet tidak diproses jika belum isi form persetujuan di atas. Terima kasih.
      </Text>
      <Checkbox
        onChange={(e) => onChangeValue('general', 'isTnCApproved')(e.target.checked)}
        checked={isTnCApproved}
        disabled={isLoading}
        data-testid="tnc-checkbox"
      >
        Saya sudah mengisi consent form
      </Checkbox>
    </div>
  );
}

export { TnCForm };
